module.exports = __webpack_public_path__ + "img/info-2.08b4ce2d.svg";